import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../../../../components/Form/types/types";
import { CardCombinationsTable } from "./CardCombinationsTable";

export const CardCombinationsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <CardCombinationsTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
